export default __webpack_public_path__ + "static/media/mode-2002.6db7c80c.svg";